import { useEffect, useMemo, useRef } from 'react';

// // 监听容器进入视窗，用于实现触底滚动
export const useIntersection = (callback: () => void) => {
  // 锚点ref
  const anchorRef = useRef<HTMLDivElement>(null);

  // 监视的锚点
  const anchor = useMemo(() => {
    return <div ref={anchorRef}></div>;
  }, []);

  useEffect(() => {
    const initIntersectionObserver = () => {
      let intersectionObserver: IntersectionObserver | null = null;
      try {
        intersectionObserver = new IntersectionObserver((entries) => {
          const item = entries[0];
          if (item.isIntersecting) {
            callback();
          }
        });
        if (anchorRef.current) {
          intersectionObserver.observe(anchorRef.current);
        }
      } catch (e) {
        console.error(e);
      }
      return intersectionObserver;
    };
    const intersectionObserver = initIntersectionObserver();

    return () => {
      intersectionObserver?.disconnect?.();
    };
  }, [callback]);

  return {
    anchor,
  };
};
